<script setup lang="ts">
  const { data } = await useFetch(`https://api.benevolt.fr/v1/stats`)
</script>

<template>
  <div class="relative bg-primary">
    <div class="absolute inset-x-0 bottom-0 xl:top-0 xl:h-full">
      <div class="h-full w-full xl:grid xl:grid-cols-4">
        <div class="h-full xl:relative xl:col-start-2 col-span-3">
          <img class="h-full w-full object-cover opacity-25 xl:absolute xl:inset-0" src="/team-benevolt-sept-2024.jpg" alt="Équipe Benevolt">
          <div aria-hidden="true" class="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-primary xl:inset-y-0 xl:left-0 xl:h-full xl:w-44 xl:bg-gradient-to-r"></div>
        </div>
      </div>
    </div>
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 xl:grid xl:grid-cols-2 xl:grid-flow-col-dense xl:gap-x-8 text-white">
      <div class="relative pt-12 pb-96 sm:pt-24 sm:pb-96 xl:col-start-1 xl:pb-24">
        <h2 class="text-sm font-semibold tracking-wide uppercase">
          Expertise & Numérique
        </h2>
        <p class="mt-3 text-3xl font-extrabold">L’engagement associatif se transforme !<br>Il est nécessaire d’agir pour soutenir une société solidaire et créatrice de lien social.</p>
        <p class="mt-5 text-lg">Depuis 2017, nous accompagnons les associations et les collectivités dans la compréhension des enjeux de l’engagement aujourd’hui. Nos solutions clé en main vous permettent de bénéficier de notre expertise au quotidien et de vous appuyer sur des outils numériques innovants.</p>
        <p class="mt-1 text-lg"><ULink to="/a-propos" class="underline text-white">En savoir plus</ULink></p>
        <div class="mt-12 grid grid-cols-1 gap-y-12 gap-x-6 sm:grid-cols-2">

          <p>
            <span class="text-xl font-semibold"><span class="text-2xl font-bold">{{data?.networks}}</span> réseaux nationaux et <span class="text-2xl font-bold">{{data?.cities}}</span> villes</span>
            <span class="text-base"><span class="font-medium"> ont embarqué</span></span>
          </p>

          <p>
            <span class="text-xl font-semibold"><span class="text-2xl font-bold">{{data?.organizations}}</span> associations locales</span>
            <span class="text-base"><span class="font-medium"></span> utilisent nos services</span>
          </p>

          <p>
            <span class="text-xl font-semibold"><span class="text-2xl font-bold">{{data?.volunteers}}</span> bénévoles</span>
            <span class="text-base"> utilisent nos services <br><span class="text-xs">(Benevolt et plateformes d’engagement dédiées)</span></span>
          </p>

          <p>
            <span class="text-xl font-semibold"><span class="text-2xl font-bold">{{data?.handshakes}}</span> belles histoires</span>
            <span class="text-base"><span class="font-medium"> ont débuté entre associations et bénévoles</span> sur les 12 derniers mois</span>
          </p>

          <p class="text-center">
            <img class="sm:-mt-6 mb-2 m-auto" src="/ESUSlogo.png" alt="Macaron ESUS (Entreprise solidaire d'utilité sociale)">
            <span class="mt-1 block text-xs text-white">
							<span class="font-medium text-white">Entreprise Solidaire d'Utilité Sociale</span><br>
							Agrément ESUS délivré par l’État
						</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>